/* =============================================================================
   assets/no-helmet-addon-1021.js   (HELMET-ADDONS-1021, Bon 21 Oct 2026). NEW FILE.
   Bon: "fix up all product pages that sell fast sf helmet as addon ... so that
   the fast sf vented are now showing stocked accordingly with the correct etas
   ... and also show the right images and color options".

   One script for every kind of GEN II FAST SF helmet add on the store renders:
     A. the theme's white box upsell block   product-info-upsell[data-handle="fast-sf-helmet"]
     B. the dark lander rows (PVS-14, PVS-31, ADV-COTI, GPNVG-18, DFB-31)
                                            [aria-label="View GEN II FAST SF VENTED HELMET details"]
     C. the HEAT / VIPER dark buy column    [data-hvd-row="helmet"]
     D. the HEAT / VIPER white rows         [data-hv-row="helmet"]
     E. the PREDATOR kit helmet row         .no-pk__addon (the one naming FAST SF)
   It never adds to a cart and never changes which variant a widget sends: each
   widget keeps its own cart call. What it does:
     1. a DELIVERY LINE under the picked helmet, asked of the same delivery
        estimate service the product page card uses, word for word:
          shelf    "In stock at our US warehouse. Get it by <a> to <b>."
          on a box the service's own "On its way ... Ships in about ..." line
          sold out "Sold out in this size and colour."
     2. SOLID shells are never offered (vented only, Bon 14 Oct): a SHELL menu
        is set to VENTED and hidden.
     3. colours in the helmet page's own order (Black, Ranger Green, Tan) and,
        for the six pill list, size first (Medium then Large) like the page.
     4. the picture follows the picked colour (vented shell in that colour,
        from the helmet product's own variant pictures) where a widget opens on
        another picture.
     5. a pick the store cannot sell is greyed and marked sold out, never hidden.
   US market only (the helmet is not sold elsewhere; abroad the rows show the
   GEN I listing and this file does nothing). No em or en dashes.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__noHelmetAddon1021) return;
  window.__noHelmetAddon1021 = true;

  var EP = 'https://tsqimuxhpcqmqlkmnznj.supabase.co/functions/v1/delivery-estimate';
  var COLOR_ORDER = ['BLACK', 'RANGER GREEN', 'TAN'];
  var SIZE_ORDER = ['MEDIUM', 'LARGE'];
  var SHORT = { BLK: 'BLACK', BLACK: 'BLACK', RG: 'RANGER GREEN', 'RANGER GREEN': 'RANGER GREEN', TAN: 'TAN',
                M: 'MEDIUM', MEDIUM: 'MEDIUM', L: 'LARGE', LARGE: 'LARGE' };
  var TTL = 10 * 60 * 1000;
  var V = null;            /* key "SIZE|COLOR" -> {id, sku, ok, img} for vented variants */
  var BY_ID = {};
  var EST = {};            /* sku -> answer or 'wait' */
  /* HELMET-ADDON-CUTOUT-1028 (Bon 28 Oct): every add-on card shows the vented helmet cut out on a clear background,
     like the other add-on cards. Same photos as the helmet's own variant pictures, background removed.
     The helmet product's own gallery is not changed. Undo: STORE-FIXES-1022\WORK\helmet-cut-1028\golive.py undo */
  var CUT = { 'BLACK': "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/helmet-addon-cut-black-1028.png?v=1793141890", 'RANGER GREEN': "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/helmet-addon-cut-ranger-green-1028.png?v=1793141899", 'TAN': "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/helmet-addon-cut-tan-1028.png?v=1793141909" };
  var CUT_FROM = { 'gen2-fast-sf-vented-helmet-black.png': 'BLACK', 'vented-ranger-green-v1.png': 'RANGER GREEN', 'vented-tan-v1.png': 'TAN' };

  function country() {
    try { return (window.Shopify && window.Shopify.country) || ''; } catch (e) { return ''; }
  }
  function up(s) { return String(s == null ? '' : s).trim().toUpperCase(); }
  function norm(s) { s = up(s).replace(/\s*-\s*(SOLD OUT|UNAVAILABLE)\s*$/, ''); return SHORT[s] || s; }
  function ss(k, v) {
    try {
      if (v === undefined) { var r = JSON.parse(sessionStorage.getItem(k) || 'null'); return r && (Date.now() - r.t < TTL) ? r.d : null; }
      sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: v }));
    } catch (e) { return null; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* the vented variants, keyed "SIZE|COLOR". First from the data the page itself prints
     (snippets/no-helmet-addon-1021.liquid, read when the page was built), else from the store, with retries. */
  function mapOf(options, variants) {
    var names = (options || []).map(function (o) { return up(typeof o === 'string' ? o : o.name); });
    var iS = names.indexOf('SIZE'), iC = names.indexOf('COLOR'), iH = names.indexOf('SHELL');
    var out = {};
    (variants || []).forEach(function (v) {
      var o = v.o || [v.option1, v.option2, v.option3];
      if (iH >= 0 && up(o[iH]) !== 'VENTED') return;
      var img = typeof v.img === 'string' ? v.img : (v.featured_image ? (v.featured_image.src || '') : '');
      img = CUT[up(o[iC])] || img; /* HELMET-ADDON-CUTOUT-1028 */
      out[up(o[iS]) + '|' + up(o[iC])] = { id: v.id, sku: v.sku || '', ok: v.ok !== undefined ? !!v.ok : !!v.available, img: img };
    });
    return Object.keys(out).length ? out : null;
  }
  function loadProduct(cb, tries) {
    var pre = window.__noheV ? mapOf(window.__noheV.o, window.__noheV.v) : null;
    if (pre) return cb(pre);
    var c = ss('nohe1021:p');
    if (c) return cb(c);
    tries = tries || 0;
    fetch('/products/fast-sf-helmet.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (p) {
        var out = mapOf(p.options, p.variants);
        if (!out) return;
        ss('nohe1021:p', out);
        cb(out);
      })
      .catch(function () { if (tries < 3) setTimeout(function () { loadProduct(cb, tries + 1); }, 1500 * (tries + 1)); });
  }

  function estimate(sku, cb) {
    if (!sku) return;
    var c = EST[sku] || ss('nohe1021:e:' + sku);
    if (c && c !== 'wait') return cb(c);
    if (c === 'wait') return;
    EST[sku] = 'wait';
    var ctl = null;
    try { ctl = new AbortController(); setTimeout(function () { ctl.abort(); }, 5000); } catch (e) {}
    fetch(EP + '?sku=' + encodeURIComponent(sku) + '&country=US&cur=USD', ctl ? { signal: ctl.signal, credentials: 'omit' } : { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { EST[sku] = d || {}; ss('nohe1021:e:' + sku, EST[sku]); paintAll(); })
      .catch(function () { delete EST[sku]; setTimeout(paintAll, 3000); });
  }

  /* the words, the same sentences the product page card prints */
  function words(v) {
    if (!v) return null;
    if (!v.ok) return { tone: 'out', html: 'Sold out in this size and colour.' };
    var d = EST[v.sku];
    if (!d || d === 'wait' || !d.show) return null;
    if (d.mode === 'eta' && d.min_label && d.max_label) {
      return { tone: 'stock', html: 'In stock at our US warehouse. Get it by <strong>' + esc(d.min_label) + '</strong> to <strong>' + esc(d.max_label) + '</strong>.' };
    }
    if (d.mode === 'inbound' && d.lead_text) {
      return { tone: 'inbound', html: esc(d.lead_text) + (d.note_text ? ' <span class="nohe-note">' + esc(d.note_text) + '</span>' : '') };
    }
    if (d.mode === 'out_of_stock') return { tone: 'out', html: esc(d.lead_text || 'Sold out in this size and colour.') };
    return null;
  }

  function line(host, after, v, dark) {
    var el = host.querySelector(':scope [data-nohe-line]');
    var w = words(v);
    if (v && v.ok) estimate(v.sku, function () {});
    if (!w) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-nohe-line', '');
      el.className = 'nohe-line';
      el.setAttribute('aria-live', 'polite');
      if (after && after.parentNode) after.parentNode.insertBefore(el, after.nextSibling);
      else host.appendChild(el);
    }
    el.hidden = false;
    el.classList.toggle('nohe-line--dark', onDark(el));
    el.setAttribute('data-tone', w.tone);
    var html = '<span class="nohe-dot" aria-hidden="true"></span><span>' + w.html + '</span>';
    if (el.__h !== html) { el.innerHTML = html; el.__h = html; }
  }

  /* light or dark ink, read from the first painted background behind the line */
  function onDark(el) {
    var e = el.parentElement;
    while (e && e !== document.documentElement) {
      var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(getComputedStyle(e).backgroundColor || '');
      if (m && (m[4] === undefined || Number(m[4]) > 0.5)) {
        return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255 < 0.45;
      }
      e = e.parentElement;
    }
    return false;
  }
  function key(size, color) { return norm(size) + '|' + norm(color); }
  function setImg(img, v) {
    if (!img || !v || !v.img) return;
    var base = v.img.split('?')[0].split('/').pop();
    var cur = (img.getAttribute('src') || '').split('?')[0].split('/').pop();
    if (base && cur !== base) {
      img.removeAttribute('srcset');
      img.setAttribute('src', /[?&]width=\d+/.test(v.img) ? v.img.replace(/([?&])width=\d+/, '$1width=400')
        : v.img + (v.img.indexOf('?') >= 0 ? '&' : '?') + 'width=400');
    }
  }
  function orderSelect(sel, order) {
    var opts = Array.prototype.slice.call(sel.options);
    var want = opts.slice().sort(function (a, b) {
      var ia = order.indexOf(norm(a.value || a.text)), ib = order.indexOf(norm(b.value || b.text));
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    if (want.some(function (o, i) { return o !== opts[i]; })) {
      var val = sel.value;
      want.forEach(function (o) { sel.appendChild(o); });
      sel.value = val;
    }
  }
  function shellHide(sel) {
    if (!sel) return;
    var vented = Array.prototype.filter.call(sel.options, function (o) { return /VENTED/i.test(o.value || o.text); })[0];
    if (vented && sel.value !== vented.value) {
      sel.value = vented.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    /* hide the menu with its own heading: the largest wrapper that holds this menu and no other */
    var box = sel;
    while (box.parentElement && box.parentElement.querySelectorAll('select').length === 1 &&
           !box.parentElement.matches('product-info-upsell, [data-hv-row], .no-pk__addon')) box = box.parentElement;
    box.style.display = 'none';
    box.setAttribute('data-nohe-hidden', 'shell');
  }
  function menus(host) {
    var m = {};
    Array.prototype.forEach.call(host.querySelectorAll('select'), function (s) {
      var t = Array.prototype.map.call(s.options, function (o) { return up(o.value || o.text); }).join('|');
      var n = up(s.name + ' ' + (s.getAttribute('aria-label') || '') + ' ' + (s.getAttribute('data-option') || ''));
      if (/SHELL/.test(n) || /VENTED/.test(t)) m.shell = s;
      else if (/COLOU?R/.test(n) || /TAN/.test(t)) m.color = s;
      else if (/SIZE/.test(n) || /MEDIUM|LARGE/.test(t)) m.size = s;
    });
    return m;
  }
  function markMenu(sel, size, color, isColor) {
    if (!sel) return;
    Array.prototype.forEach.call(sel.options, function (o) {
      var k = isColor ? key(size, o.value || o.text) : key(o.value || o.text, color);
      var v = V[k];
      var out = v ? !v.ok : false;
      var label = o.getAttribute('data-nohe-label') || o.text.replace(/\s*-\s*(Sold out|Unavailable)$/i, '');
      if (!o.getAttribute('data-nohe-label')) o.setAttribute('data-nohe-label', label);
      if (v) { o.disabled = out; o.text = out ? label + ' - Sold out' : label; }
    });
  }

  /* A and D and E: anything built from select menus */
  function paintMenus(host, dark) {
    var m = menus(host);
    if (!m.color) return;
    if (m.shell) shellHide(m.shell);
    orderSelect(m.color, COLOR_ORDER);
    if (m.size) orderSelect(m.size, SIZE_ORDER);
    var size = m.size ? m.size.value : 'MEDIUM';
    var v = V[key(size, m.color.value)];
    markMenu(m.color, size, m.color.value, true);
    if (m.size) markMenu(m.size, size, m.color.value, false);
    setImg(host.querySelector('img'), v);
    /* the line goes right under the block that holds every menu (their nearest shared parent) */
    var anchor = m.color;
    if (m.size) { while (anchor && anchor !== host && !anchor.contains(m.size)) anchor = anchor.parentElement; }
    else { anchor = m.color.parentElement; }
    if (!anchor || anchor === host) anchor = m.color.parentElement;
    line(host, anchor, v, dark);
  }

  /* B: the dark lander rows (BLK TAN RG buttons, M L buttons) */
  function pressed(b) {
    if (b.getAttribute('aria-pressed') === 'true' || b.getAttribute('aria-checked') === 'true') return true;
    var c = ' ' + (b.className || '') + ' ';
    return / border-accent /.test(c) && / text-accent /.test(c);
  }
  function paintDark(row) {
    var btns = Array.prototype.slice.call(row.querySelectorAll('button')).filter(function (b) { return b.getAttribute('role') !== 'switch'; });
    var cols = btns.filter(function (b) { return SHORT[up(b.textContent)] && COLOR_ORDER.indexOf(SHORT[up(b.textContent)]) >= 0; });
    var sizes = btns.filter(function (b) { return SHORT[up(b.textContent)] && SIZE_ORDER.indexOf(SHORT[up(b.textContent)]) >= 0; });
    if (cols.length > 1) {
      var parent = cols[0].parentNode;
      var same = cols.every(function (b) { return b.parentNode === parent; });
      var want = cols.slice().sort(function (a, b) { return COLOR_ORDER.indexOf(norm(a.textContent)) - COLOR_ORDER.indexOf(norm(b.textContent)); });
      if (same && want.some(function (b, i) { return b !== cols[i]; })) {
        var anchor = cols[cols.length - 1].nextSibling;
        want.forEach(function (b) { parent.insertBefore(b, anchor); });
      }
    }
    var c = cols.filter(pressed)[0], s = sizes.filter(pressed)[0];
    var color = c ? c.textContent : 'BLACK', size = s ? s.textContent : 'MEDIUM';
    var v = V[key(size, color)];
    cols.forEach(function (b) {
      var vv = V[key(size, b.textContent)];
      var out = vv ? !vv.ok : false;
      b.classList.toggle('nohe-out', out);
      if (out) b.setAttribute('title', norm(b.textContent).toLowerCase() + ', sold out');
    });
    sizes.forEach(function (b) {
      var vv = V[key(b.textContent, color)];
      b.classList.toggle('nohe-out', vv ? !vv.ok : false);
    });
    var optBox = cols.length ? cols[0].parentNode : null;
    var textCol = optBox ? optBox.parentNode : (row.querySelector('.flex-1') || row);
    line(textCol, optBox, v, true);
  }

  /* C: the HEAT / VIPER six pill list */
  function paintPills(row) {
    var pills = Array.prototype.slice.call(row.querySelectorAll('[data-hvd-opt]'));
    if (!pills.length) return;
    var parent = pills[0].parentNode;
    function rank(p) {
      var v = BY_ID[p.getAttribute('data-v')];
      if (!v) return 99;
      var k = v.k.split('|');
      return SIZE_ORDER.indexOf(k[0]) * 10 + COLOR_ORDER.indexOf(k[1]);
    }
    var want = pills.slice().sort(function (a, b) { return rank(a) - rank(b); });
    if (want.some(function (p, i) { return p !== pills[i]; })) want.forEach(function (p) { parent.appendChild(p); });
    pills.forEach(function (p) {
      var v = BY_ID[p.getAttribute('data-v')];
      var out = v ? !v.ok : false;
      p.classList.toggle('nohe-out', out);
      if (out && !/SOLD OUT/i.test(p.textContent)) p.setAttribute('aria-label', p.textContent.trim() + ', sold out');
    });
    var on = pills.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0];
    var id = on ? on.getAttribute('data-v') : null;
    if (!id) {
      var a = row.querySelector('[data-hvd-vlink]');
      var m = a && /variant=(\d+)/.exec(a.getAttribute('href') || '');
      id = m ? m[1] : null;
    }
    var v = id ? BY_ID[id] : null;
    if (v) setImg(row.querySelector('[data-hvd-vimg]'), v);
    line(parent.parentNode, parent, v, true);
  }

  /* HEADLINE-1021: on HEAT / VIPER a second press on the picked helmet pill used to unpick it. Stop that press before
     the page's own handler sees it; the ADD A HELMET switch is still the way to drop the helmet. */
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-hvd-opt="helmet"][aria-checked="true"]') : null;
    if (c) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  var busy = false;
  function paintAll() {
    if (!V || busy) return;
    busy = true;
    try {
      Array.prototype.forEach.call(document.querySelectorAll('product-info-upsell[data-handle="fast-sf-helmet"]'), function (h) { paintMenus(h, false); });
      Array.prototype.forEach.call(document.querySelectorAll('[data-hv-row="helmet"]'), function (h) { paintMenus(h, false); });
      Array.prototype.forEach.call(document.querySelectorAll('.no-pk__addon'), function (h) { if (/FAST\s*SF/i.test(h.textContent)) paintMenus(h, false); });
      Array.prototype.forEach.call(document.querySelectorAll('[aria-label="View GEN II FAST SF VENTED HELMET details"]'), paintDark);
      /* the helmet details pop up those rows open (same BLK TAN RG / M L buttons) */
      Array.prototype.forEach.call(document.querySelectorAll('dialog'), function (d) { if (/FAST SF VENTED HELMET/i.test(d.textContent)) paintDark(d); });
      Array.prototype.forEach.call(document.querySelectorAll('[data-hvd-row="helmet"]'), paintPills);
    } catch (e) { /* the widgets keep their own words */ }
    busy = false;
  }

  function css() {
    if (document.getElementById('nohe1021-css')) return;
    var s = document.createElement('style');
    s.id = 'nohe1021-css';
    s.textContent =
      '.nohe-line{display:flex;align-items:flex-start;gap:7px;margin:8px 0 0;padding:6px 9px;border-radius:6px;font-size:12px;line-height:1.4;' +
      'letter-spacing:.01em;text-transform:none;font-weight:400;text-align:left;max-width:100%;box-sizing:border-box;' +
      'background:rgba(var(--nohe-t),.12);border:1px solid rgba(var(--nohe-t),.40);color:inherit}' +
      '.nohe-line[hidden]{display:none}' +
      '.nohe-line strong{font-weight:600}' +
      '.nohe-line .nohe-note{opacity:.75}' +
      '.nohe-line[data-tone="stock"]{--nohe-t:74,155,118}' +
      '.nohe-line[data-tone="inbound"]{--nohe-t:37,99,235}' +
      '.nohe-line[data-tone="out"]{--nohe-t:180,35,24}' +
      '.nohe-dot{flex:0 0 auto;width:7px;height:7px;border-radius:50%;margin-top:5px;background:rgb(var(--nohe-t))}' +
      '.nohe-line--dark{color:rgba(255,255,255,.86)}' +
      '.nohe-line--dark[data-tone="inbound"]{--nohe-t:96,145,255}' +
      '.nohe-out{opacity:.4;text-decoration:line-through}';
    document.head.appendChild(s);
  }

  function start() {
    if (country() && country() !== 'US') return;
    var any = document.querySelector('product-info-upsell[data-handle="fast-sf-helmet"],[data-hv-row="helmet"],.no-pk__addon,[aria-label="View GEN II FAST SF VENTED HELMET details"],[data-hvd-row="helmet"]');
    if (!any) return;
    css();
    /* HELMET-ADDON-CUTOUT-1028: swap a white backdrop helmet picture at once, before the variant data arrives */
    Array.prototype.forEach.call(document.querySelectorAll('product-info-upsell[data-handle="fast-sf-helmet"] img,[data-hv-row="helmet"] img,.no-pk__addon img,[data-hvd-row="helmet"] [data-hvd-vimg]'), function (im) {
      var c = CUT_FROM[(im.getAttribute('src') || '').split('?')[0].split('/').pop()];
      if (c) setImg(im, { img: CUT[c] });
    });
    loadProduct(function (map) {
      V = map;
      Object.keys(map).forEach(function (k) { map[k].k = k; BY_ID[String(map[k].id)] = map[k]; });
      /* ask for every buyable vented helmet once, so a new pick shows its line at once */
      Object.keys(map).forEach(function (k) { if (map[k].ok) estimate(map[k].sku, function () {}); });
      paintAll();
      [400, 1200, 3000, 6000].forEach(function (t) { setTimeout(paintAll, t); });
      var later = function () { setTimeout(paintAll, 60); setTimeout(paintAll, 450); };
      document.addEventListener('click', later, true);
      document.addEventListener('change', later, true);
      document.addEventListener('variant:change', later);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 300); });
  else setTimeout(start, 300);
})();
